import {
  UPDATE_REPORTS_POST_LIST,
  UPDATE_REPORTS_USER_LIST,
  UPDATE_REPORTS_POST_LIST_LOADING,
  UPDATE_REPORTS_USER_LIST_LOADING,
  UPDATE_REPORTED_USER_DETAILS,
  UPDATE_REPORTEDBY_USER_LIST,
  UPDATE_REPORTED_POST_DETAILS,
  UPDATE_REPORTEDBY_USER_LIST_FOR_POST,
  UPDATE_REPORTEDBY_USER_LIST_LOADING_FOR_POST,
  UPDATE_REPORTEDBY_USER_LIST_LOADING_FOR_USER,
} from "../../store/actionTypes";

class TableList {
  isLoading = false;
  total = 0;
  pageNo = 1;
  limit = 10;
  totalPage = 0;
  searchKey = "";
  sortOrder = 1;
  sortBy = "firstName";
  dataList = [];
}
class PostTableList {
  isLoading = false;
  total = 0;
  pageNo = 1;
  limit = 10;
  totalPage = 0;
  searchKey = "";
  sortOrder = 1;
  sortBy = "title";
  dataList = [];
}
class ReportedByTableList {
  isLoading = false;
  total = 0;
  pageNo = 1;
  limit = 10;
  totalPage = 0;
  searchKey = "";
  sortOrder = 1;
  sortBy = "name";
  dataList = [];
}


const initialState = {
  user: {
    reportedUsers: new TableList(),
    userDetails: {},
    reportedByUsers: new ReportedByTableList(),
  },
  post: {
    reportedPost: new PostTableList(),
    reportedByUsers: new ReportedByTableList(),
    postDetails: {},
  },
};

/**
 *
 * @param {initial state of reducer} state
 * @param { perform actions } action
 * @returns updated state of reducer
 */
const ReportReducer = (state = initialState, action) => {
  const toggleLoading = (target) => ({
    ...target,
    isLoading: !target.isLoading,
  });

  switch (action.type) {
    case UPDATE_REPORTS_USER_LIST:
      return {
        ...state,
        user: {
          ...state.user,
          reportedUsers: {
            ...state.user.reportedUsers,
            ...action.payload,
          },
        },
      };

    case UPDATE_REPORTS_USER_LIST_LOADING:
      return {
        ...state,
        user: {
          ...state.user,
          reportedUsers: toggleLoading(state.user.reportedUsers),
        },
      };

    case UPDATE_REPORTED_USER_DETAILS:
      return {
        ...state,
        user: {
          ...state.user,
          userDetails: {
            ...action.payload,
          },
        },
      };

    case UPDATE_REPORTEDBY_USER_LIST:
      return {
        ...state,
        user: {
          ...state.user,
          reportedByUsers: {
            ...state.user.reportedByUsers,
            ...action.payload,
          },
        },
      };

    case UPDATE_REPORTEDBY_USER_LIST_LOADING_FOR_USER:
      return {
        ...state,
        user: {
          ...state.user,
          reportedByUsers: toggleLoading(state.user.reportedByUsers),
        },
      };

    case UPDATE_REPORTS_POST_LIST:
      return {
        ...state,
        post: {
          ...state.post,
          reportedPost: {
            ...state.post.reportedPost,
            ...action.payload,
          },
        },
      };

    case UPDATE_REPORTS_POST_LIST_LOADING:
      return {
        ...state,
        post: {
          ...state.post,
          reportedPost: toggleLoading(state.post.reportedPost),
        },
      };

    case UPDATE_REPORTED_POST_DETAILS:
      return {
        ...state,
        post: {
          ...state.post,
          postDetails: {
            ...action.payload,
          },
        },
      };

    case UPDATE_REPORTEDBY_USER_LIST_FOR_POST:
      return {
        ...state,
        post: {
          ...state.post,
          reportedByUsers: {
            ...state.post.reportedByUsers,
            ...action.payload,
          },
        },
      };

    case UPDATE_REPORTEDBY_USER_LIST_LOADING_FOR_POST:
      return {
        ...state,
        post: {
          ...state.post,
          reportedByUsers: toggleLoading(state.post.reportedByUsers),
        },
      };
    default:
      return state;
  }
};

export default ReportReducer;
